import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-patient-card',
    templateUrl: './patient-card.component.html',
    styleUrls: ['./patient-card.component.scss'],
    standalone: false
})
export class PatientCardComponent implements OnInit {
  @Input() dataForCard: Array<any>;
  @Output() editEllipseClick: EventEmitter<any> = new EventEmitter();
  @Output() footerLinksClick: EventEmitter<any> = new EventEmitter();
  
  constructor() { }

  ngOnInit() {
    console.log("Data For Card is ",this.dataForCard);
  }
  public cardFooterLinksClick(event){
    this.footerLinksClick.emit({ event });
  }
  private emitEllipseId(data: any, actionType) {
    this.editEllipseClick.emit({ data, actionType });
  }
  public checkEllipseMenu(data: any) {
    if (data.config) {
        for(let i = 0; i < data.config.buttonMenu.length; i++) {
            if (!data.config.buttonMenu[i].button) {
                return true;
            } else {
                return false;
            }
        }
    }
    else {
        return false;
    }
}
}

